<div class="row">
  <div class="col-md-12 d-flex flex-row">
    <div class="d-flex flex-auto measure-setting-header">
      {{'measure.setting' | translate}}
    </div>
    <div class="d-flex flex-row align-items-center" *ngIf="isPersistedReport()">
      <a class="measure-setting-icon"
         actionByLevels="Edit Project"
         [wallName]="'Reports Disabled'"
         [actionData]="getMeasureContextByAction('edit')"
         (afterChecking)="onAllowToEditReport($event)">
        <img src="/assets/images/Edit_Icon.svg" width="13" height="13">
      </a>
      <a class="measure-setting-icon" *ngIf="isPersistedReport()"
         actionByLevels="Edit Project"
         [wallName]="'Reports Disabled'"
         [actionData]="getMeasureContextByAction('delete')"
         (afterChecking)="onShowDeleteWarningPopup($event)">
        <img src="/assets/images/Trash_Icon.svg" width="13" height="13">
      </a>
    </div>
  </div>
  <div class="col-md-12 mt-10px">
    <p class="measure-setting-content">{{'measure.setting_message' | translate}}</p>
  </div>
  <div class="col-md-12 measure-setting-period-container">
    <div class="measure-date-range">
      <div class="date-range-container">
        <span class="popup-filter-title">{{'measure.period_label' | translate}}</span>
        <span class="period-time date-range-selection"
              actionByLevels="Custom reports"
              [wallName]="'Reports Disabled'"
              [actionData]="getMeasureContextByAction('edit')"
              (afterChecking)="onClickDateRangePopup($event)"
              placement="bottom"
              ngbTooltip="{{'info_box.measure.date_range' | translate}}">
          {{formatReportDateRange}}
        </span>
        <div class="measure-date-selection-area" [ngClass]="{'open': showDateRangePopup, 'hide': !showDateRangePopup}">
          <measure-date-range-selection #measureDateRangePicker
                                        [preSelectedPeriod]="selectedPeriod"
                                        (hideDateRangePopupEvent)="hideDateRangePopup($event)"
                                        (changeDateRange)="onChangePeriod($event)">
          </measure-date-range-selection>
        </div>
      </div>
    </div>
  </div>
</div>
<achoo-popup #deleteReportWarning
             [isAlertPopup]="true"
             acceptBtnLabel="{{'measure.delete_yes' | translate}}"
             cancelBtnLabel="{{'measure.delete_no' | translate}}"
             (acceptCallback)="deleteReport()"
             (cancelCallback)="hideDeleteWarningPopup()">
  <div>
    {{'measure.delete_message' | translate:{report_name: getReportName(selectedReport)} }}
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-setting/measure-setting.component.html